module.exports = __webpack_public_path__ + "static/img/3_1.107f9139.jpg";